'use strict';

module.exports = [
	'<div class="companies-dropdown">',
	'<a class="adb-context_menu--trigger"><%-currentCompany%></a>',
	'<ul class="adb-context_menu--menu">',
	'  <% _.each(companies, function(company) { %>',
	'  <li><a onClick="changeCompanyContext(\'<%-userId%>\', \'<%-company.companyId%>\')"><%= company.label %></a></li>',
	'<% });%>',
	'</ul>',
	'</div>'
].join('\n');




//////////////////
// WEBPACK FOOTER
// ./~/ad-theme-customizer-client/src/deprecated/templates/company-dropdown.tpl.js
// module id = 49
// module chunks = 0